/**
 * API 模块入口文件
 * 整合和导出所有API函数
 */

// 导入配置
export { API_PATHS, RETRY_CONFIG, RATE_LIMIT_CONFIG } from "./config";

// 导入通用工具函数
export {
  isDevelopment,
  delay,
  calculateRetryDelay,
  getCurrentUser,
  saveCurrentUser,
  fetchWithRetry,
  handleStreamResponse,
  convertImageToBase64,
  requestManager,
  setCustomClientSlug,
  getCustomClientSlug,
  cleanErrorMessage,
} from "./utils";

// 导入认证相关API
export {
  sendVerificationCode,
  verifyCode,
  registerUser,
  loginUser,
  logoutUser,
  loginWithPassword,
  registerWithPassword,
  changePassword,
  resetPassword,
  getEmailWhitelist,
  validateEmailDomain,
} from "./authApi";

// 导入用户相关API
export {
  getUserInfo,
  updateUserInfo,
  getUserList,
} from "./userApi";

// 导入积分相关API
export {
  checkUserCredits,
  confirmCreditCharge,
  rechargeCredits,
  adminAddCredits,
} from "./creditsApi";

// 导入Manim相关API
export { streamManimCode, streamFixManimCode, streamRefineCode } from "./manimApi";

// 导入GeoGebra相关API
export { streamGeoGebraCode } from "./geogebraApi";

// 导入Three.js相关API
export { streamThreeJSCode } from "./threejsApi";

// 导入解题相关API
export { streamSolveQuestion, streamSolveQuestionVideo } from "./solveApi";

// 导入模式配置相关API
export { getModeConfigs, getCachedModeConfigs, refreshModeConfigs } from "./modeConfigApi";

// 导入TTS配置相关API
export { getPublicTtsConfig, getCachedTtsConfig } from "./ttsApi";

// 导入BGM配置相关API
export { getPublicBgmConfig, getCachedBgmConfig, DEFAULT_BGM_TRACKS } from "./bgmApi";

// 导入作品展示相关API
export { saveGeneratedShowcase, updateShowcaseThumbnail, updateShowcaseInputImage, updateShowcaseInputImages, getShowcaseList, getRecommendedShowcases } from "./showcaseApi";

// 导入图片相关API
export { getImageCategories, getImagesByCategory, preloadImages } from "./imageApi";

// 导入QQ模式相关API
export { streamQQAnalysis, extractQQHTMLCode } from "./qqApi";

// 导入公告相关API
export {
  getActiveAnnouncements,
  getPopupAnnouncements,
  shouldShowAnnouncementPopup,
  dismissAnnouncementForToday,
  clearAnnouncementDismiss
} from "./announcementApi";

// 用户意见反馈
export { submitFeedback, getFeedbackRewards } from "./feedbackApi";

// 分享裂变
export { getReferralShareInfo } from "./referralApi";

// 导入AI修饰相关API
export { streamPromptEnhance } from "./promptEnhanceApi";

// 导入用户预设相关API
export {
  getUserPresets,
  getActivePreset,
  getPresetById,
  createPreset,
  updatePreset,
  deletePreset,
  activatePreset,
  deactivateAllPresets,
  PRESET_OPTIONS
} from "./presetApi";

// 导入皮肤管理相关API
export {
  getActiveSkin,
  getCachedActiveSkin,
  DEFAULT_FALLBACK_SKIN,
} from "./skinApi";

// 导入单个测试API函数
export const testAPIConnection = async (onSuccess, onError) => {
  try {
    const requestBody = {
      mode: "test",
      prompt: '请回复"API连接正常"',
      stream: false,
    };

    // 添加用户ID到请求中
    const currentUser = getCurrentUser();
    requestBody.userId = currentUser?.id || 0;

    const response = await axiosInstance.post(
      `${API_PATHS.BASE_API_URL}${API_PATHS.PROXY.MODEL}`,
      requestBody
    );

    const data = response.data;
    Logger.info("API测试成功", data);
    onSuccess(data);
  } catch (error) {
    Logger.error("API测试出错", error);
    onError(`API测试出错: ${error.message}`);
  }
};

// 导入axiosInstance
import axiosInstance from "../services/axiosConfig";
import Logger from "../utils/logger";

// 默认导出所有API函数
export default {
  // 测试相关
  testAPIConnection,
};
